import React from "react";
import { Segment, Header, Icon } from "semantic-ui-react";
import "./NotificationsList.scss";

export function NotificationsList(props) {
  const { notifications } = props;

  return (
    <Segment className="dashboard-segment info-segment">
      <Header as="h3" dividing>
        <Icon name="bell outline" />
        Notificaciones Recientes
      </Header>
      {notifications?.notifications?.length > 0 ? (
        <div className="notifications-list">
          {notifications.notifications.slice(0, 4).map((notif, index) => (
            <div className="notification-item" key={notif.id || index}>
              <div
                className={`notification-icon ${
                  notif.priority === "high" ? "warning" : "info"
                }`}
              >
                <Icon
                  name={notif.priority === "high" ? "exclamation" : "info"}
                />
              </div>
              <div className="notification-content-dashboard">
                <div className="title">{notif.title}</div>
                <div className="message">{notif.message}</div>
              </div>
              <div className="notification-time">
                <Icon name="clock outline" size="small" />
                {notif.createdAt
                  ? new Date(notif.createdAt).toLocaleDateString("es-PE")
                  : "Reciente"}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <Icon name="bell slash outline" />
          <p>No tienes notificaciones nuevas.</p>
        </div>
      )}
    </Segment>
  );
}
